// extracted by mini-css-extract-plugin
export default {"container":"ContactsPage_container__o7tqt","title":"ContactsPage_title__rNimo","phone":"ContactsPage_phone__qaCx1","email":"ContactsPage_email__DvSu-"};